import { render, staticRenderFns } from "./MonthlyConsumptionComparison.vue?vue&type=template&id=c4ff24da&lang=pug&"
import script from "./MonthlyConsumptionComparison.vue?vue&type=script&lang=ts&"
export * from "./MonthlyConsumptionComparison.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports